import { IButtonProps } from "@/shared/interfaces/ReUsedComponentsProps";
import "./Button.scss";

const variantClasses = {
    approved: "approved",
    cancel: "cancel",
    delete: "delete",
    "edit-small": "edit-small",
    "delete-small": "delete-small",
};

export default function Button({
    text,
    type,
    variant,
    onClick,
    disabled,
    isLoading,
    style,
    id,
}: IButtonProps) {
    const variantClass = variantClasses[variant] || "";
    const buttonClasses = `button ${variantClass}`;

    return (
        <button
            id={id}
            type={type}
            onClick={onClick}
            className={buttonClasses}
            disabled={disabled || isLoading}
            style={style}
        >
            {variant === "delete" || variant === "approved" ? (
                !isLoading ? (
                    text
                ) : (
                    <img
                        src='/animations/spinner-gif.gif'
                        alt='spinner'
                        width={variant === "delete" ? "40" : "30"}
                        height={variant === "delete" ? "40" : "30"}
                    />
                )
            ) : (
                text
            )}
        </button>
    );
}
